import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Row, Form, FormGroup, Input, Col, Pagination, PaginationItem, PaginationLink, Button, Label } from 'reactstrap'
import CompaniesTable from './CompaniesTable'
import LoadingSpinner from '../Shared/LoadingSpinner'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import PageHeading from '../Shared/LayoutComponents/PageHeading'
import useFetchingManagedReconCompanies from './useFetchingManagedReconCompanies'
import { AzureAD } from 'react-aad-msal'
import store from '../../store/configureStore'
import { authProvider } from '../../services/authProvider'

let ShowCompletedCol = styled(Col)`
  padding-top: 7px;
  padding-left: 50px;
`

const Reconciliation = (props) => {
  useFetchingManagedReconCompanies()
  let pageSize = 10
  const [companies, setCompanies] = useState([])
  const [filteredCompanies, setfilteredCompanies] = useState([])
  const [searchCompany, setSearchCompany] = useState('')
  const [showCompleted, setShowCompleted] = useState(false)
  const [pagesCount, setPagesCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)

  const applyFilters = (allCompanies, search, includeCompleted) => {
    let filtered = allCompanies

    // Default: companies with New/InProgress recons this month
    // Show completed: also include companies with Completed recons this month
    if (includeCompleted) {
      filtered = filtered.filter((company) => company.hasPendingThisMonth || company.hasCompletedThisMonth)
    } else {
      filtered = filtered.filter((company) => company.hasPendingThisMonth)
    }

    if (search) {
      filtered = filtered.filter((company) =>
        company.name.toLowerCase().includes(search.toLowerCase())
      )
    }

    setfilteredCompanies(filtered)
    setPagesCount(Math.ceil(filtered.length / pageSize))
    setCurrentPage(0)
  }

  const handleCompletedToggle = () => {
    const newValue = !showCompleted
    setShowCompleted(newValue)
    applyFilters(companies, searchCompany, newValue)
  }

  const handleSearchChange = (event) => {
    const value = event.target.value
    setSearchCompany(value)
    applyFilters(companies, value, showCompleted)
  }

  useEffect(() => {
    if (props.companyList && props.companyList.length > 0) {
      setCompanies(props.companyList)
      applyFilters(props.companyList, searchCompany, showCompleted)
    }
  }, [props.companyList])

  if (props.loading) {
    return <LoadingSpinner />
  } else {
    return (
      <AzureAD provider={authProvider} reduxStore={store}>
        {({ login, logout, authenticationState, accountInfo }) => {
          let isAdmin = false
          let isSales = false
          if (accountInfo && accountInfo.account && accountInfo.account.idToken && accountInfo.account.idToken.roles) {
            if (accountInfo.account.idToken.roles.includes('Admin')) {
              isAdmin = true
              isSales = true
            } else if (accountInfo.account.idToken.roles.includes('Sales')) {
              isSales = true
            }
          }
          return (
            <PageContainer>
              <Link to="/Reconciliation/ReUpload">
                {(isSales || isAdmin) && (
                  <Button color="primary" className="float-right">
                    Post Invoice Re-Upload
                  </Button>
                )}
              </Link>
              <Row>
                <PageHeading fullWidth={true}>Managed Reconciliation</PageHeading>
              </Row>
              <div>
                <Pagination aria-label="Page navigation example" style={{ float: 'right' }}>
                  <PaginationItem disabled={currentPage <= 0}>
                    <PaginationLink onClick={() => setCurrentPage(currentPage - 1)} previous href="#" />
                  </PaginationItem>
                  {[...Array(pagesCount)].map((page, i) => (
                    <PaginationItem active={i === currentPage} key={i}>
                      <PaginationLink onClick={() => setCurrentPage(i)} href="#">
                        {i + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}
                  <PaginationItem disabled={currentPage >= pagesCount - 1}>
                    <PaginationLink onClick={() => setCurrentPage(currentPage + 1)} next href="#" />
                  </PaginationItem>
                </Pagination>
              </div>
              <Form>
                <FormGroup row>
                  <Col sm={4}>
                    <Input
                      onChange={handleSearchChange}
                      value={searchCompany}
                      type="search"
                      name="search"
                      id="Search"
                      placeholder="Search for a company"
                    />
                  </Col>
                  <ShowCompletedCol sm={3}>
                    <Label check>
                      <Input type="checkbox" id="ShowCompleted" checked={showCompleted} onChange={handleCompletedToggle} />{' '}
                      Show completed
                    </Label>
                  </ShowCompletedCol>
                </FormGroup>
              </Form>
              <CompaniesTable
                isAdmin={isAdmin}
                isSales={isSales}
                currentPage={currentPage}
                pageSize={pageSize}
                companies={filteredCompanies}
              />
            </PageContainer>
          )
        }}
      </AzureAD>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.recon.loading,
  companyList: state.recon.companyList,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Reconciliation)
